export const askForPriceleadButtonCopy = "Zapytaj o cenę";
export const askForOfferLeadButtonCopy = "Zapytaj o ofertę";
